// Updated App.tsx route configuration
import React, { useEffect } from "react";
import { Loader } from "@sebgroup/react-components/dist/Loader";
import { AppRoute } from "../utils/functions";
import { Redirect, Switch, RouteComponentProps, withRouter } from "react-router";
import { AuthState, States } from '../interfaces/states';
import { useSelector } from 'react-redux';
import { store } from "../store/configureStore";
import { receiveAuth, authActions } from '../actions/authActions';
import { actionTypes } from "../types";
import NotificationHook from "./shared/NotificationHook";
import { AppRoutes, HomeRoutes } from '../enums/routes';
import Signup from './account/signupForm/Signup';
import CheckApiValue from "./shared/version";
import { version } from "../actions/pageSizeAction";
import axios from "axios";
import PublicRFQ from "./account/publicUrls/PublicRFQ";
import PublicPO from "./account/publicUrls/publicPO";
import { ThemeProvider } from "../utils/ThemeContext";
import PublicServiceApproval from "./account/publicUrls/PublicServiceApproval";
import PublicServiceAssetApproval from "./account/publicUrls/PublicServiceAssetApproval";

const NotFound: React.LazyExoticComponent<React.FunctionComponent<RouteComponentProps>> = React.lazy(() => import("./notFound/404"));
const Home: any = React.lazy(() => import("./home/Home"));

// UPDATED: Import the new unified dashboard containers
const PublicMFEDashboard: React.LazyExoticComponent<React.FC> = React.lazy(
  () => import("./home/dashboardItem/PublicMFEDashboardContainer")
);

const Account: any = React.lazy(() => import("./account/Account"));
const Auth: any = React.lazy(() => import("./account/signinForm/Signin"));
const SignUp: any = React.lazy(() => import("./account/signupForm/Signup"));
const PublicBreakdown: any = React.lazy(() => import("./account/publicUrls/PublicBreakdown"));

export interface SharedProps extends RouteComponentProps {
  actions: actionTypes;
}

const App: React.FunctionComponent<SharedProps> = React.memo((props: SharedProps): React.ReactElement<void> => {
  const authState: AuthState = useSelector((states: States) => states?.auth);
  const authStatee = useSelector((states: States) => states?.pageSize);

  const [value, setValue] = React.useState<any>(null);

  const checkApi = async () => {
    try {
      const response = await axios.get('https://api.prod.senshost.com/frontend/version');
      const newValue = response.data;
      setValue(newValue);
      if (!authStatee?.version) {
        store.dispatch(version(''));
      }

      if (newValue !== authStatee?.version) {
        store.dispatch(version(newValue));
        caches.keys().then((names) => {
          Promise.all(names.map(name => caches.delete(name))).then(() => {
            window.location.reload();
          });
        });
      }
    } catch (error) {
      console.error('Error fetching data from API:', error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(checkApi, 30000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      <ThemeProvider>
        <NotificationHook />
        <React.Suspense fallback={<Loader toggle={true} />}>
          <Switch>
            <Redirect exact from="/" to={AppRoutes.Home} />

            {/* UPDATED: Use the new unified MFE dashboard component */}
            <AppRoute
              path="/mfe/dashboard/:dashboardId"
              component={PublicMFEDashboard}
              props={props}
            />

            {/* <AppRoute
                                  path={HomeRoutes.MFEDashboard.toString()}
                                  exact
                                  component={PublicMFEDashboard}
                                /> */}

            {/* Alternative MFE routes with different configurations */}


            <AppRoute
              path="/public/dashboard/:dashboardId"
              component={() => (
                <AppRoute
                  path="/mfe/dashboarditem/:dashboardId"
                  component={PublicMFEDashboard}
                  props={props}
                />
              )}
              props={props}
            />

            <AppRoute path={AppRoutes.Account} component={(Account)} props={props} />
            <AppRoute path={AppRoutes.Login} component={(Auth)} props={props} />
            <AppRoute path={AppRoutes.SignUp} component={(SignUp)} props={props} />
            <AppRoute path={AppRoutes.PublicBreakdown} component={(PublicBreakdown)} props={props} />
            <AppRoute path={AppRoutes.PublicRFQ} component={(PublicRFQ)} props={props} />
            <AppRoute path={AppRoutes.PublicPO} component={(PublicPO)} props={props} />
            <AppRoute path={AppRoutes.PublicServiceApproval} component={(PublicServiceApproval)} props={props} />
            <AppRoute path={AppRoutes.PublicServiceAssetApproval} component={(PublicServiceAssetApproval)} props={props} />
            <AppRoute path={AppRoutes.Home} component={(Home)} props={props} />
            <AppRoute path="*" component={NotFound} props={props} />
          </Switch>
        </React.Suspense>
      </ThemeProvider>
    </div>
  );
});

export default withRouter<any, any>(App);